import { isEmpty } from "lodash";

const response = (data) => {
  const normalizedResponse = data.map((slot, i) => {
    const tabCode = slot?.code || null;
    const tabName = slot.name || "Rack";
    const tabkey = (i + 1).toString();
    const columns = slot.slots.map((obj, o) => {
      let isColumnEmpty = isEmpty(obj.boxData) ? true : false;
      let columnNo = obj.name || (o + 1).toString();
      if (!isColumnEmpty) {
        const { boxData } = obj;
        const boxInfo = {
          boxName: boxData.box.name || boxData.box.code,
          boxNo: "1",
          status: boxData.status,
          numOfParcels: boxData.noOfParcels,
          location: boxData.sortingHubName,
          noOfExpectedParcels: boxData.noOfExpectedParcels,
          isScanned: boxData.scanned || false,
        };
        return { boxInfo, isColumnEmpty, columnNo };
      }

      return { isColumnEmpty, columnNo };
    });
    const noOfColumns = slot?.noOfColumns ?? 0;

    return { tabCode, tabName, tabkey, noOfColumns, columns };
  });

  return normalizedResponse;
};
export default response;
